/* ÜRETİLDİ — elle düzenleme. Kaynak: packages/tokens/tokens.json · `pnpm --filter @halkora/tokens build` */

/** Bileşenlerde KULLANILACAK olan: rol adı → "var(--hk-…)". Ham değer yerine bunu yaz. */
export const cssVar = Object.freeze({
  "bg.base": "var(--hk-bg-base)",
  "bg.surface": "var(--hk-bg-surface)",
  "bg.content": "var(--hk-bg-content)",
  "bg.raised": "var(--hk-bg-raised)",
  "bg.overlay": "var(--hk-bg-overlay)",
  "bg.hover": "var(--hk-bg-hover)",
  "bg.active": "var(--hk-bg-active)",
  "bg.selected": "var(--hk-bg-selected)",
  "bg.inset": "var(--hk-bg-inset)",
  "bg.skeleton": "var(--hk-bg-skeleton)",
  "bg.scrim": "var(--hk-bg-scrim)",
  "bg.glow": "var(--hk-bg-glow)",
  "surface.blur": "var(--hk-surface-blur)",
  "surface.glass": "var(--hk-surface-glass)",
  "text.primary": "var(--hk-text-primary)",
  "text.secondary": "var(--hk-text-secondary)",
  "text.muted": "var(--hk-text-muted)",
  "text.disabled": "var(--hk-text-disabled)",
  "text.inverse": "var(--hk-text-inverse)",
  "text.link": "var(--hk-text-link)",
  "border.subtle": "var(--hk-border-subtle)",
  "border.default": "var(--hk-border-default)",
  "border.strong": "var(--hk-border-strong)",
  "border.input": "var(--hk-border-input)",
  "accent.base": "var(--hk-accent-base)",
  "accent.hover": "var(--hk-accent-hover)",
  "accent.pressed": "var(--hk-accent-pressed)",
  "accent.on": "var(--hk-accent-on)",
  "accent.text": "var(--hk-accent-text)",
  "accent.subtle": "var(--hk-accent-subtle)",
  "accent.ring": "var(--hk-accent-ring)",
  "voice.base": "var(--hk-voice-base)",
  "voice.hover": "var(--hk-voice-hover)",
  "voice.on": "var(--hk-voice-on)",
  "voice.text": "var(--hk-voice-text)",
  "voice.subtle": "var(--hk-voice-subtle)",
  "voice.speaking": "var(--hk-voice-speaking)",
  "voice.card": "var(--hk-voice-card)",
  "voice.cardOn": "var(--hk-voice-card-on)",
  "voice.cardRing": "var(--hk-voice-card-ring)",
  "danger.base": "var(--hk-danger-base)",
  "danger.hover": "var(--hk-danger-hover)",
  "danger.on": "var(--hk-danger-on)",
  "danger.text": "var(--hk-danger-text)",
  "danger.subtle": "var(--hk-danger-subtle)",
  "warning.base": "var(--hk-warning-base)",
  "warning.on": "var(--hk-warning-on)",
  "warning.text": "var(--hk-warning-text)",
  "warning.subtle": "var(--hk-warning-subtle)",
  "success.base": "var(--hk-success-base)",
  "success.on": "var(--hk-success-on)",
  "success.text": "var(--hk-success-text)",
  "success.subtle": "var(--hk-success-subtle)",
  "presence.online": "var(--hk-presence-online)",
  "presence.idle": "var(--hk-presence-idle)",
  "presence.dnd": "var(--hk-presence-dnd)",
  "presence.offline": "var(--hk-presence-offline)",
  "mention.bg": "var(--hk-mention-bg)",
  "mention.bar": "var(--hk-mention-bar)",
  "mention.border": "var(--hk-mention-border)",
  "mention.chip": "var(--hk-mention-chip)",
  "mention.chipText": "var(--hk-mention-chip-text)",
  "focus": "var(--hk-focus)",
  "live": "var(--hk-live)",
  "shadow.none": "var(--hk-shadow-none)",
  "shadow.overlay": "var(--hk-shadow-overlay)",
  "shadow.toast": "var(--hk-shadow-toast)",
  "shadow.speaking": "var(--hk-shadow-speaking)",
  "radius.lg": "var(--hk-radius-lg)",
  "radius.md": "var(--hk-radius-md)",
  "radius.xs": "var(--hk-radius-xs)",
  "radius.sm": "var(--hk-radius-sm)",
  "radius.xl": "var(--hk-radius-xl)",
  "font.family.sans": "var(--hk-font-family-sans)",
  "font.family.mono": "var(--hk-font-family-mono)",
  "font.family.ui": "var(--hk-font-family-ui)",
  "font.size.xs": "var(--hk-font-size-xs)",
  "font.size.sm": "var(--hk-font-size-sm)",
  "font.size.base": "var(--hk-font-size-base)",
  "font.size.md": "var(--hk-font-size-md)",
  "font.size.lg": "var(--hk-font-size-lg)",
  "font.size.xl": "var(--hk-font-size-xl)",
  "font.size.2xl": "var(--hk-font-size-2xl)",
  "font.lineHeight.xs": "var(--hk-font-line-height-xs)",
  "font.lineHeight.sm": "var(--hk-font-line-height-sm)",
  "font.lineHeight.base": "var(--hk-font-line-height-base)",
  "font.lineHeight.md": "var(--hk-font-line-height-md)",
  "font.lineHeight.lg": "var(--hk-font-line-height-lg)",
  "font.lineHeight.xl": "var(--hk-font-line-height-xl)",
  "font.lineHeight.2xl": "var(--hk-font-line-height-2xl)",
  "font.weight.regular": "var(--hk-font-weight-regular)",
  "font.weight.medium": "var(--hk-font-weight-medium)",
  "font.weight.semibold": "var(--hk-font-weight-semibold)",
  "font.weight.bold": "var(--hk-font-weight-bold)",
  "font.tracking.tight": "var(--hk-font-tracking-tight)",
  "font.tracking.normal": "var(--hk-font-tracking-normal)",
  "font.tracking.wide": "var(--hk-font-tracking-wide)",
  "space.0": "var(--hk-space-0)",
  "space.1": "var(--hk-space-1)",
  "space.2": "var(--hk-space-2)",
  "space.3": "var(--hk-space-3)",
  "space.4": "var(--hk-space-4)",
  "space.5": "var(--hk-space-5)",
  "space.6": "var(--hk-space-6)",
  "space.8": "var(--hk-space-8)",
  "space.10": "var(--hk-space-10)",
  "space.12": "var(--hk-space-12)",
  "space.16": "var(--hk-space-16)",
  "space.0_5": "var(--hk-space-0_5)",
  "space.1_5": "var(--hk-space-1_5)",
  "radius.none": "var(--hk-radius-none)",
  "radius.server": "var(--hk-radius-server)",
  "radius.full": "var(--hk-radius-full)",
  "ring.width": "var(--hk-ring-width)",
  "ring.offset": "var(--hk-ring-offset)",
  "ring.speakingWidth": "var(--hk-ring-speaking-width)",
  "ring.speakingOffset": "var(--hk-ring-speaking-offset)",
  "ring.selectedWidth": "var(--hk-ring-selected-width)",
  "border.width": "var(--hk-border-width)",
  "motion.duration.instant": "var(--hk-motion-duration-instant)",
  "motion.duration.fast": "var(--hk-motion-duration-fast)",
  "motion.duration.normal": "var(--hk-motion-duration-normal)",
  "motion.easing.standard": "var(--hk-motion-easing-standard)",
  "motion.easing.enter": "var(--hk-motion-easing-enter)",
  "motion.easing.exit": "var(--hk-motion-easing-exit)",
  "motion.delay.skeleton": "var(--hk-motion-delay-skeleton)",
  "motion.delay.tooltip": "var(--hk-motion-delay-tooltip)",
  "z.base": "var(--hk-z-base)",
  "z.sticky": "var(--hk-z-sticky)",
  "z.rail": "var(--hk-z-rail)",
  "z.dropdown": "var(--hk-z-dropdown)",
  "z.settings": "var(--hk-z-settings)",
  "z.modal": "var(--hk-z-modal)",
  "z.toast": "var(--hk-z-toast)",
  "z.tooltip": "var(--hk-z-tooltip)",
  "layout.gap": "var(--hk-layout-gap)",
  "layout.rail": "var(--hk-layout-rail)",
  "layout.railIcon": "var(--hk-layout-rail-icon)",
  "layout.channelList": "var(--hk-layout-channel-list)",
  "layout.memberList": "var(--hk-layout-member-list)",
  "layout.userBar": "var(--hk-layout-user-bar)",
  "layout.header": "var(--hk-layout-header)",
  "layout.connectionStrip": "var(--hk-layout-connection-strip)",
  "layout.composerMin": "var(--hk-layout-composer-min)",
  "layout.messageAvatar": "var(--hk-layout-message-avatar)",
  "layout.messageGutter": "var(--hk-layout-message-gutter)",
  "layout.voiceTileMin": "var(--hk-layout-voice-tile-min)",
  "layout.modalSm": "var(--hk-layout-modal-sm)",
  "layout.modalMd": "var(--hk-layout-modal-md)",
  "layout.modalLg": "var(--hk-layout-modal-lg)",
  "layout.settingsNav": "var(--hk-layout-settings-nav)",
  "layout.settingsContent": "var(--hk-layout-settings-content)",
  "layout.contentMin": "var(--hk-layout-content-min)",
  "layout.menuMin": "var(--hk-layout-menu-min)",
  "layout.membersBreakpoint": "var(--hk-layout-members-breakpoint)",
  "layout.mobileBreakpoint": "var(--hk-layout-mobile-breakpoint)",
  "layout.drawer": "var(--hk-layout-drawer)",
  "layout.toastMax": "var(--hk-layout-toast-max)",
  "layout.emptyMax": "var(--hk-layout-empty-max)",
  "layout.focusStrip": "var(--hk-layout-focus-strip)",
  "layout.mediaMaxW": "var(--hk-layout-media-max-w)",
  "layout.mediaMaxH": "var(--hk-layout-media-max-h)",
  "size.control.sm": "var(--hk-size-control-sm)",
  "size.control.md": "var(--hk-size-control-md)",
  "size.control.lg": "var(--hk-size-control-lg)",
  "size.icon.sm": "var(--hk-size-icon-sm)",
  "size.icon.md": "var(--hk-size-icon-md)",
  "size.icon.lg": "var(--hk-size-icon-lg)",
  "size.iconStroke": "var(--hk-size-icon-stroke)",
  "size.avatar.xs": "var(--hk-size-avatar-xs)",
  "size.avatar.sm": "var(--hk-size-avatar-sm)",
  "size.avatar.md": "var(--hk-size-avatar-md)",
  "size.avatar.lg": "var(--hk-size-avatar-lg)",
  "size.avatar.xl": "var(--hk-size-avatar-xl)",
  "size.row.category": "var(--hk-size-row-category)",
  "size.row.channel": "var(--hk-size-row-channel)",
  "size.row.voiceUser": "var(--hk-size-row-voice-user)",
  "size.row.menuItem": "var(--hk-size-row-menu-item)",
  "size.row.member": "var(--hk-size-row-member)",
  "size.chip": "var(--hk-size-chip)",
  "size.switch.width": "var(--hk-size-switch-width)",
  "size.switch.height": "var(--hk-size-switch-height)",
  "size.switch.thumb": "var(--hk-size-switch-thumb)",
  "size.checkbox": "var(--hk-size-checkbox)",
  "size.attachmentThumb": "var(--hk-size-attachment-thumb)",
  "size.presenceDot": "var(--hk-size-presence-dot)",
  "size.badgeMin": "var(--hk-size-badge-min)",
  "size.unreadPip": "var(--hk-size-unread-pip)"
});

/** Rol adı → CSS değişken adı ("--hk-…"). */
export const cssDegisken = Object.freeze({
  "bg.base": "--hk-bg-base",
  "bg.surface": "--hk-bg-surface",
  "bg.content": "--hk-bg-content",
  "bg.raised": "--hk-bg-raised",
  "bg.overlay": "--hk-bg-overlay",
  "bg.hover": "--hk-bg-hover",
  "bg.active": "--hk-bg-active",
  "bg.selected": "--hk-bg-selected",
  "bg.inset": "--hk-bg-inset",
  "bg.skeleton": "--hk-bg-skeleton",
  "bg.scrim": "--hk-bg-scrim",
  "bg.glow": "--hk-bg-glow",
  "surface.blur": "--hk-surface-blur",
  "surface.glass": "--hk-surface-glass",
  "text.primary": "--hk-text-primary",
  "text.secondary": "--hk-text-secondary",
  "text.muted": "--hk-text-muted",
  "text.disabled": "--hk-text-disabled",
  "text.inverse": "--hk-text-inverse",
  "text.link": "--hk-text-link",
  "border.subtle": "--hk-border-subtle",
  "border.default": "--hk-border-default",
  "border.strong": "--hk-border-strong",
  "border.input": "--hk-border-input",
  "accent.base": "--hk-accent-base",
  "accent.hover": "--hk-accent-hover",
  "accent.pressed": "--hk-accent-pressed",
  "accent.on": "--hk-accent-on",
  "accent.text": "--hk-accent-text",
  "accent.subtle": "--hk-accent-subtle",
  "accent.ring": "--hk-accent-ring",
  "voice.base": "--hk-voice-base",
  "voice.hover": "--hk-voice-hover",
  "voice.on": "--hk-voice-on",
  "voice.text": "--hk-voice-text",
  "voice.subtle": "--hk-voice-subtle",
  "voice.speaking": "--hk-voice-speaking",
  "voice.card": "--hk-voice-card",
  "voice.cardOn": "--hk-voice-card-on",
  "voice.cardRing": "--hk-voice-card-ring",
  "danger.base": "--hk-danger-base",
  "danger.hover": "--hk-danger-hover",
  "danger.on": "--hk-danger-on",
  "danger.text": "--hk-danger-text",
  "danger.subtle": "--hk-danger-subtle",
  "warning.base": "--hk-warning-base",
  "warning.on": "--hk-warning-on",
  "warning.text": "--hk-warning-text",
  "warning.subtle": "--hk-warning-subtle",
  "success.base": "--hk-success-base",
  "success.on": "--hk-success-on",
  "success.text": "--hk-success-text",
  "success.subtle": "--hk-success-subtle",
  "presence.online": "--hk-presence-online",
  "presence.idle": "--hk-presence-idle",
  "presence.dnd": "--hk-presence-dnd",
  "presence.offline": "--hk-presence-offline",
  "mention.bg": "--hk-mention-bg",
  "mention.bar": "--hk-mention-bar",
  "mention.border": "--hk-mention-border",
  "mention.chip": "--hk-mention-chip",
  "mention.chipText": "--hk-mention-chip-text",
  "focus": "--hk-focus",
  "live": "--hk-live",
  "shadow.none": "--hk-shadow-none",
  "shadow.overlay": "--hk-shadow-overlay",
  "shadow.toast": "--hk-shadow-toast",
  "shadow.speaking": "--hk-shadow-speaking",
  "radius.lg": "--hk-radius-lg",
  "radius.md": "--hk-radius-md",
  "radius.xs": "--hk-radius-xs",
  "radius.sm": "--hk-radius-sm",
  "radius.xl": "--hk-radius-xl",
  "font.family.sans": "--hk-font-family-sans",
  "font.family.mono": "--hk-font-family-mono",
  "font.family.ui": "--hk-font-family-ui",
  "font.size.xs": "--hk-font-size-xs",
  "font.size.sm": "--hk-font-size-sm",
  "font.size.base": "--hk-font-size-base",
  "font.size.md": "--hk-font-size-md",
  "font.size.lg": "--hk-font-size-lg",
  "font.size.xl": "--hk-font-size-xl",
  "font.size.2xl": "--hk-font-size-2xl",
  "font.lineHeight.xs": "--hk-font-line-height-xs",
  "font.lineHeight.sm": "--hk-font-line-height-sm",
  "font.lineHeight.base": "--hk-font-line-height-base",
  "font.lineHeight.md": "--hk-font-line-height-md",
  "font.lineHeight.lg": "--hk-font-line-height-lg",
  "font.lineHeight.xl": "--hk-font-line-height-xl",
  "font.lineHeight.2xl": "--hk-font-line-height-2xl",
  "font.weight.regular": "--hk-font-weight-regular",
  "font.weight.medium": "--hk-font-weight-medium",
  "font.weight.semibold": "--hk-font-weight-semibold",
  "font.weight.bold": "--hk-font-weight-bold",
  "font.tracking.tight": "--hk-font-tracking-tight",
  "font.tracking.normal": "--hk-font-tracking-normal",
  "font.tracking.wide": "--hk-font-tracking-wide",
  "space.0": "--hk-space-0",
  "space.1": "--hk-space-1",
  "space.2": "--hk-space-2",
  "space.3": "--hk-space-3",
  "space.4": "--hk-space-4",
  "space.5": "--hk-space-5",
  "space.6": "--hk-space-6",
  "space.8": "--hk-space-8",
  "space.10": "--hk-space-10",
  "space.12": "--hk-space-12",
  "space.16": "--hk-space-16",
  "space.0_5": "--hk-space-0_5",
  "space.1_5": "--hk-space-1_5",
  "radius.none": "--hk-radius-none",
  "radius.server": "--hk-radius-server",
  "radius.full": "--hk-radius-full",
  "ring.width": "--hk-ring-width",
  "ring.offset": "--hk-ring-offset",
  "ring.speakingWidth": "--hk-ring-speaking-width",
  "ring.speakingOffset": "--hk-ring-speaking-offset",
  "ring.selectedWidth": "--hk-ring-selected-width",
  "border.width": "--hk-border-width",
  "motion.duration.instant": "--hk-motion-duration-instant",
  "motion.duration.fast": "--hk-motion-duration-fast",
  "motion.duration.normal": "--hk-motion-duration-normal",
  "motion.easing.standard": "--hk-motion-easing-standard",
  "motion.easing.enter": "--hk-motion-easing-enter",
  "motion.easing.exit": "--hk-motion-easing-exit",
  "motion.delay.skeleton": "--hk-motion-delay-skeleton",
  "motion.delay.tooltip": "--hk-motion-delay-tooltip",
  "z.base": "--hk-z-base",
  "z.sticky": "--hk-z-sticky",
  "z.rail": "--hk-z-rail",
  "z.dropdown": "--hk-z-dropdown",
  "z.settings": "--hk-z-settings",
  "z.modal": "--hk-z-modal",
  "z.toast": "--hk-z-toast",
  "z.tooltip": "--hk-z-tooltip",
  "layout.gap": "--hk-layout-gap",
  "layout.rail": "--hk-layout-rail",
  "layout.railIcon": "--hk-layout-rail-icon",
  "layout.channelList": "--hk-layout-channel-list",
  "layout.memberList": "--hk-layout-member-list",
  "layout.userBar": "--hk-layout-user-bar",
  "layout.header": "--hk-layout-header",
  "layout.connectionStrip": "--hk-layout-connection-strip",
  "layout.composerMin": "--hk-layout-composer-min",
  "layout.messageAvatar": "--hk-layout-message-avatar",
  "layout.messageGutter": "--hk-layout-message-gutter",
  "layout.voiceTileMin": "--hk-layout-voice-tile-min",
  "layout.modalSm": "--hk-layout-modal-sm",
  "layout.modalMd": "--hk-layout-modal-md",
  "layout.modalLg": "--hk-layout-modal-lg",
  "layout.settingsNav": "--hk-layout-settings-nav",
  "layout.settingsContent": "--hk-layout-settings-content",
  "layout.contentMin": "--hk-layout-content-min",
  "layout.menuMin": "--hk-layout-menu-min",
  "layout.membersBreakpoint": "--hk-layout-members-breakpoint",
  "layout.mobileBreakpoint": "--hk-layout-mobile-breakpoint",
  "layout.drawer": "--hk-layout-drawer",
  "layout.toastMax": "--hk-layout-toast-max",
  "layout.emptyMax": "--hk-layout-empty-max",
  "layout.focusStrip": "--hk-layout-focus-strip",
  "layout.mediaMaxW": "--hk-layout-media-max-w",
  "layout.mediaMaxH": "--hk-layout-media-max-h",
  "size.control.sm": "--hk-size-control-sm",
  "size.control.md": "--hk-size-control-md",
  "size.control.lg": "--hk-size-control-lg",
  "size.icon.sm": "--hk-size-icon-sm",
  "size.icon.md": "--hk-size-icon-md",
  "size.icon.lg": "--hk-size-icon-lg",
  "size.iconStroke": "--hk-size-icon-stroke",
  "size.avatar.xs": "--hk-size-avatar-xs",
  "size.avatar.sm": "--hk-size-avatar-sm",
  "size.avatar.md": "--hk-size-avatar-md",
  "size.avatar.lg": "--hk-size-avatar-lg",
  "size.avatar.xl": "--hk-size-avatar-xl",
  "size.row.category": "--hk-size-row-category",
  "size.row.channel": "--hk-size-row-channel",
  "size.row.voiceUser": "--hk-size-row-voice-user",
  "size.row.menuItem": "--hk-size-row-menu-item",
  "size.row.member": "--hk-size-row-member",
  "size.chip": "--hk-size-chip",
  "size.switch.width": "--hk-size-switch-width",
  "size.switch.height": "--hk-size-switch-height",
  "size.switch.thumb": "--hk-size-switch-thumb",
  "size.checkbox": "--hk-size-checkbox",
  "size.attachmentThumb": "--hk-size-attachment-thumb",
  "size.presenceDot": "--hk-size-presence-dot",
  "size.badgeMin": "--hk-size-badge-min",
  "size.unreadPip": "--hk-size-unread-pip"
});

/** v('bg.surface') → "var(--hk-bg-surface)" */
export function v(ad) {
  const d = cssVar[ad];
  if (!d) throw new Error('Bilinmeyen token: ' + ad);
  return d;
}

export const TEMALAR = Object.freeze([
  "dark",
  "light",
  "dev",
  "render_light",
  "render_dark"
]);
export const VARSAYILAN_TEMA = 'dark';

/** Çözülmüş tema renkleri — yalnız CSS değişkeni kullanılamayan yerde (canvas, grafik, Electron yerel). */
export const tema = Object.freeze({
  "dark": {
    "bg.base": "#0d0b1a",
    "bg.surface": "#161329",
    "bg.content": "#1a1630",
    "bg.raised": "#201c3b",
    "bg.overlay": "#262145",
    "bg.hover": "#262145",
    "bg.active": "#2f2a54",
    "bg.selected": "#32295a",
    "bg.inset": "#120f24",
    "bg.skeleton": "#262145",
    "bg.scrim": "rgba(8, 6, 18, 0.78)",
    "bg.glow": "radial-gradient(1200px 600px at 10% -10%, #3a2a7a, transparent), radial-gradient(900px 500px at 110% 110%, #7a3a2a, transparent)",
    "surface.blur": "14px",
    "surface.glass": "72%",
    "text.primary": "#eef0ff",
    "text.secondary": "#b4b9e0",
    "text.muted": "#969cc4",
    "text.disabled": "#6c7099",
    "text.inverse": "#0d0b1a",
    "text.link": "#ffa959",
    "border.subtle": "#262244",
    "border.default": "#352f5e",
    "border.strong": "#48407d",
    "border.input": "#756ea8",
    "accent.base": "#ff9d42",
    "accent.hover": "#ffa959",
    "accent.pressed": "#e68832",
    "accent.on": "#1a0f05",
    "accent.text": "#ffa959",
    "accent.subtle": "#2e1c10",
    "accent.ring": "#ff9d42",
    "voice.base": "#2cd4a3",
    "voice.hover": "#4ce0b4",
    "voice.on": "#03210d",
    "voice.text": "#4ce0b4",
    "voice.subtle": "#0c331a",
    "voice.speaking": "#2cd4a3",
    "voice.card": "#0c331a",
    "voice.cardOn": "#4ce0b4",
    "voice.cardRing": "#2cd4a3",
    "danger.base": "#d73449",
    "danger.hover": "#b8273a",
    "danger.on": "#ffffff",
    "danger.text": "#ff7b8c",
    "danger.subtle": "#3a101b",
    "warning.base": "#ffb547",
    "warning.on": "#1f1400",
    "warning.text": "#ffc46b",
    "warning.subtle": "#382305",
    "success.base": "#40d67a",
    "success.on": "#03210d",
    "success.text": "#62e293",
    "success.subtle": "#0c331a",
    "presence.online": "#40d67a",
    "presence.idle": "#ffb547",
    "presence.dnd": "#ff5470",
    "presence.offline": "#6c7099",
    "mention.bg": "#2e1c10",
    "mention.bar": "#ff9d42",
    "mention.border": "#ff9d42",
    "mention.chip": "#472712",
    "mention.chipText": "#ffd3a8",
    "focus": "#ff9d42",
    "live": "#d73449",
    "shadow.none": "none",
    "shadow.overlay": "0 16px 40px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.1)",
    "shadow.toast": "0 8px 28px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08)",
    "shadow.speaking": "0 0 28px rgba(44, 212, 163, 0.45)",
    "radius.lg": "20px",
    "radius.md": "12px",
    "radius.xs": "4px",
    "radius.sm": "6px",
    "radius.xl": "16px",
    "font.family.sans": "'Space Grotesk Variable', 'Space Grotesk', system-ui, -apple-system, sans-serif",
    "font.family.mono": "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace",
    "font.family.ui": "'Space Grotesk Variable', 'Space Grotesk', system-ui, -apple-system, sans-serif"
  },
  "light": {
    "bg.base": "#f3ede3",
    "bg.surface": "#fffaf2",
    "bg.content": "#fffaf2",
    "bg.raised": "#fffaf2",
    "bg.overlay": "#ffffff",
    "bg.hover": "#ebe2d5",
    "bg.active": "#e2d5c3",
    "bg.selected": "#f6e3d6",
    "bg.inset": "#ede5da",
    "bg.skeleton": "#ebe2d5",
    "bg.scrim": "rgba(43, 33, 24, 0.45)",
    "bg.glow": "none",
    "surface.blur": "0px",
    "surface.glass": "100%",
    "text.primary": "#2b2118",
    "text.secondary": "#544638",
    "text.muted": "#705e4d",
    "text.disabled": "#877563",
    "text.inverse": "#fffaf2",
    "text.link": "#b53e1a",
    "border.subtle": "#e4d9c8",
    "border.default": "#d8cbba",
    "border.strong": "#c4b39e",
    "border.input": "#857362",
    "accent.base": "#cc4821",
    "accent.hover": "#b53e1a",
    "accent.pressed": "#9e3414",
    "accent.on": "#ffffff",
    "accent.text": "#b53e1a",
    "accent.subtle": "#fbebe4",
    "accent.ring": "#cc4821",
    "voice.base": "#287553",
    "voice.hover": "#206144",
    "voice.on": "#ffffff",
    "voice.text": "#206144",
    "voice.subtle": "#e4f2eb",
    "voice.speaking": "#287553",
    "voice.card": "#287553",
    "voice.cardOn": "#ffffff",
    "voice.cardRing": "#f2cf55",
    "danger.base": "#c8372d",
    "danger.hover": "#a52c24",
    "danger.on": "#ffffff",
    "danger.text": "#a52c24",
    "danger.subtle": "#fdeae6",
    "warning.base": "#e6a100",
    "warning.on": "#1f1400",
    "warning.text": "#7a5000",
    "warning.subtle": "#fef3d6",
    "success.base": "#257a37",
    "success.on": "#ffffff",
    "success.text": "#1e632d",
    "success.subtle": "#e3f5e7",
    "presence.online": "#257a37",
    "presence.idle": "#a86e00",
    "presence.dnd": "#c8372d",
    "presence.offline": "#857362",
    "mention.bg": "#fbf1eb",
    "mention.bar": "#cc4821",
    "mention.border": "#cc4821",
    "mention.chip": "#f6e3d6",
    "mention.chipText": "#9e3414",
    "focus": "#cc4821",
    "live": "#c8372d",
    "shadow.none": "none",
    "shadow.overlay": "0 12px 32px rgba(43, 33, 24, 0.12), 0 0 0 1px rgba(43, 33, 24, 0.06)",
    "shadow.toast": "0 8px 24px rgba(43, 33, 24, 0.14)",
    "shadow.speaking": "0 6px 24px rgba(43, 33, 24, 0.14)",
    "radius.lg": "22px",
    "radius.md": "14px",
    "radius.xs": "4px",
    "radius.sm": "6px",
    "radius.xl": "16px",
    "font.family.sans": "'Bricolage Grotesque Variable', 'Bricolage Grotesque', system-ui, -apple-system, sans-serif",
    "font.family.mono": "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace",
    "font.family.ui": "'Bricolage Grotesque Variable', 'Bricolage Grotesque', system-ui, -apple-system, sans-serif"
  },
  "dev": {
    "bg.base": "#0c0f0c",
    "bg.surface": "#121712",
    "bg.content": "#161d16",
    "bg.raised": "#1b231b",
    "bg.overlay": "#1f291f",
    "bg.hover": "#1f291f",
    "bg.active": "#263326",
    "bg.selected": "#233823",
    "bg.inset": "#080a08",
    "bg.skeleton": "#1f291f",
    "bg.scrim": "rgba(6, 8, 6, 0.8)",
    "bg.glow": "none",
    "surface.blur": "0px",
    "surface.glass": "100%",
    "text.primary": "#d6e5d2",
    "text.secondary": "#a2b89d",
    "text.muted": "#849c80",
    "text.disabled": "#61785e",
    "text.inverse": "#0c0f0c",
    "text.link": "#b6f36a",
    "border.subtle": "#1f2a1f",
    "border.default": "#283828",
    "border.strong": "#384f38",
    "border.input": "#5d785a",
    "accent.base": "#b6f36a",
    "accent.hover": "#c5f783",
    "accent.pressed": "#9ee04e",
    "accent.on": "#0a1405",
    "accent.text": "#b6f36a",
    "accent.subtle": "#192910",
    "accent.ring": "#b6f36a",
    "voice.base": "#36d399",
    "voice.hover": "#45bd96",
    "voice.on": "#021f11",
    "voice.text": "#45bd96",
    "voice.subtle": "#0a291a",
    "voice.speaking": "#36d399",
    "voice.card": "#0a291a",
    "voice.cardOn": "#45bd96",
    "voice.cardRing": "#36d399",
    "danger.base": "#d73449",
    "danger.hover": "#b8273a",
    "danger.on": "#ffffff",
    "danger.text": "#ff7b72",
    "danger.subtle": "#3a101b",
    "warning.base": "#ffb547",
    "warning.on": "#1f1400",
    "warning.text": "#ffc46b",
    "warning.subtle": "#382305",
    "success.base": "#56d364",
    "success.on": "#071f09",
    "success.text": "#7ee787",
    "success.subtle": "#122e15",
    "presence.online": "#56d364",
    "presence.idle": "#ffb547",
    "presence.dnd": "#f85149",
    "presence.offline": "#61785e",
    "mention.bg": "#1c2b12",
    "mention.bar": "#b6f36a",
    "mention.border": "#b6f36a",
    "mention.chip": "#243b17",
    "mention.chipText": "#d4faa4",
    "focus": "#b6f36a",
    "live": "#d73449",
    "shadow.none": "none",
    "shadow.overlay": "0 8px 24px rgba(0, 0, 0, 0.7), 0 0 0 1px #1f2a1f",
    "shadow.toast": "0 6px 16px rgba(0, 0, 0, 0.6), 0 0 0 1px #1f2a1f",
    "shadow.speaking": "none",
    "radius.lg": "4px",
    "radius.md": "2px",
    "radius.xs": "4px",
    "radius.sm": "4px",
    "radius.xl": "4px",
    "font.family.sans": "'IBM Plex Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace",
    "font.family.mono": "'IBM Plex Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace",
    "font.family.ui": "'IBM Plex Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace"
  },
  "render_light": {
    "bg.base": "#ffffff",
    "bg.surface": "#fafafa",
    "bg.content": "#ffffff",
    "bg.raised": "#fafafa",
    "bg.overlay": "#ffffff",
    "bg.hover": "#f0f0f0",
    "bg.active": "#eaeaea",
    "bg.selected": "#eaeaea",
    "bg.inset": "#fafafa",
    "bg.skeleton": "#f0f0f0",
    "bg.scrim": "rgba(0, 0, 0, 0.45)",
    "bg.glow": "none",
    "surface.blur": "0px",
    "surface.glass": "100%",
    "text.primary": "#0d0d0d",
    "text.secondary": "#4d4d4d",
    "text.muted": "#6b6b6b",
    "text.disabled": "#707070",
    "text.inverse": "#ffffff",
    "text.link": "#7b1fa2",
    "border.subtle": "#e3e3e3",
    "border.default": "#c7c7c7",
    "border.strong": "#0d0d0d",
    "border.input": "#6b6b6b",
    "accent.base": "#0d0d0d",
    "accent.hover": "#272727",
    "accent.pressed": "#000000",
    "accent.on": "#ffffff",
    "accent.text": "#7b1fa2",
    "accent.subtle": "#f4f0ff",
    "accent.ring": "#7b1fa2",
    "voice.base": "#287553",
    "voice.hover": "#206144",
    "voice.on": "#ffffff",
    "voice.text": "#206144",
    "voice.subtle": "#e4f2eb",
    "voice.speaking": "#287553",
    "voice.card": "#e4f2eb",
    "voice.cardOn": "#206144",
    "voice.cardRing": "#287553",
    "danger.base": "#c8372d",
    "danger.hover": "#a52c24",
    "danger.on": "#ffffff",
    "danger.text": "#a52c24",
    "danger.subtle": "#fdeae6",
    "warning.base": "#e6a100",
    "warning.on": "#1f1400",
    "warning.text": "#7a5000",
    "warning.subtle": "#fef3d6",
    "success.base": "#257a37",
    "success.on": "#ffffff",
    "success.text": "#1e632d",
    "success.subtle": "#e3f5e7",
    "presence.online": "#257a37",
    "presence.idle": "#a86e00",
    "presence.dnd": "#c8372d",
    "presence.offline": "#6b6b6b",
    "mention.bg": "#f4f0ff",
    "mention.bar": "#7b1fa2",
    "mention.border": "#7b1fa2",
    "mention.chip": "#e7dbff",
    "mention.chipText": "#2a0052",
    "focus": "#7b1fa2",
    "live": "#c8372d",
    "shadow.none": "none",
    "shadow.overlay": "none",
    "shadow.toast": "none",
    "shadow.speaking": "none",
    "radius.lg": "0px",
    "radius.md": "0px",
    "radius.xs": "0px",
    "radius.sm": "0px",
    "radius.xl": "0px",
    "font.family.sans": "'Inter Tight', 'Inter', system-ui, -apple-system, sans-serif",
    "font.family.mono": "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace",
    "font.family.ui": "'Inter', system-ui, -apple-system, sans-serif"
  },
  "render_dark": {
    "bg.base": "#0d0d0d",
    "bg.surface": "#141414",
    "bg.content": "#0d0d0d",
    "bg.raised": "#141414",
    "bg.overlay": "#1a1a1a",
    "bg.hover": "#222222",
    "bg.active": "#282828",
    "bg.selected": "#282828",
    "bg.inset": "#141414",
    "bg.skeleton": "#222222",
    "bg.scrim": "rgba(0, 0, 0, 0.45)",
    "bg.glow": "none",
    "surface.blur": "0px",
    "surface.glass": "100%",
    "text.primary": "#ffffff",
    "text.secondary": "#e3e3e3",
    "text.muted": "#8f8f8f",
    "text.disabled": "#999999",
    "text.inverse": "#0d0d0d",
    "text.link": "#d1b8ff",
    "border.subtle": "#272727",
    "border.default": "#404040",
    "border.strong": "#8f8f8f",
    "border.input": "#6b6b6b",
    "accent.base": "#ffffff",
    "accent.hover": "#e3e3e3",
    "accent.pressed": "#cccccc",
    "accent.on": "#0d0d0d",
    "accent.text": "#d1b8ff",
    "accent.subtle": "#2a0052",
    "accent.ring": "#d1b8ff",
    "voice.base": "#2cd4a3",
    "voice.hover": "#4ce0b4",
    "voice.on": "#03210d",
    "voice.text": "#4ce0b4",
    "voice.subtle": "#0c331a",
    "voice.speaking": "#2cd4a3",
    "voice.card": "#0c331a",
    "voice.cardOn": "#4ce0b4",
    "voice.cardRing": "#2cd4a3",
    "danger.base": "#d73449",
    "danger.hover": "#b8273a",
    "danger.on": "#ffffff",
    "danger.text": "#ff7b72",
    "danger.subtle": "#3a101b",
    "warning.base": "#ffb547",
    "warning.on": "#1f1400",
    "warning.text": "#ffc46b",
    "warning.subtle": "#382305",
    "success.base": "#56d364",
    "success.on": "#071f09",
    "success.text": "#7ee787",
    "success.subtle": "#122e15",
    "presence.online": "#56d364",
    "presence.idle": "#ffb547",
    "presence.dnd": "#f85149",
    "presence.offline": "#8f8f8f",
    "mention.bg": "#2a0052",
    "mention.bar": "#d1b8ff",
    "mention.border": "#d1b8ff",
    "mention.chip": "#48008c",
    "mention.chipText": "#e7dbff",
    "focus": "#d1b8ff",
    "live": "#d73449",
    "shadow.none": "none",
    "shadow.overlay": "none",
    "shadow.toast": "none",
    "shadow.speaking": "none",
    "radius.lg": "0px",
    "radius.md": "0px",
    "radius.xs": "0px",
    "radius.sm": "0px",
    "radius.xl": "0px",
    "font.family.sans": "'Inter Tight', 'Inter', system-ui, -apple-system, sans-serif",
    "font.family.mono": "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace",
    "font.family.ui": "'Inter', system-ui, -apple-system, sans-serif"
  }
});

/** Çözülmüş ölçüler. */
export const olcu = Object.freeze({
  "font.size.xs": "0.75rem",
  "font.size.sm": "0.8125rem",
  "font.size.base": "0.9375rem",
  "font.size.md": "1rem",
  "font.size.lg": "1.125rem",
  "font.size.xl": "1.375rem",
  "font.size.2xl": "1.75rem",
  "font.lineHeight.xs": "1rem",
  "font.lineHeight.sm": "1.125rem",
  "font.lineHeight.base": "1.375rem",
  "font.lineHeight.md": "1.5rem",
  "font.lineHeight.lg": "1.5rem",
  "font.lineHeight.xl": "1.75rem",
  "font.lineHeight.2xl": "2.125rem",
  "font.weight.regular": "400",
  "font.weight.medium": "500",
  "font.weight.semibold": "600",
  "font.weight.bold": "700",
  "font.tracking.tight": "-0.012em",
  "font.tracking.normal": "0",
  "font.tracking.wide": "0.02em",
  "space.0": "0px",
  "space.1": "4px",
  "space.2": "8px",
  "space.3": "12px",
  "space.4": "16px",
  "space.5": "20px",
  "space.6": "24px",
  "space.8": "32px",
  "space.10": "40px",
  "space.12": "48px",
  "space.16": "64px",
  "space.0_5": "2px",
  "space.1_5": "6px",
  "radius.none": "0px",
  "radius.xs": "4px",
  "radius.sm": "6px",
  "radius.xl": "16px",
  "radius.server": "14px",
  "radius.full": "9999px",
  "ring.width": "2px",
  "ring.offset": "2px",
  "ring.speakingWidth": "2px",
  "ring.speakingOffset": "2px",
  "ring.selectedWidth": "2px",
  "border.width": "1px",
  "motion.duration.instant": "0ms",
  "motion.duration.fast": "120ms",
  "motion.duration.normal": "200ms",
  "motion.easing.standard": "cubic-bezier(0.2, 0, 1)",
  "motion.easing.enter": "cubic-bezier(0, 0, 0.2, 1)",
  "motion.easing.exit": "cubic-bezier(0.4, 0, 1, 1)",
  "motion.delay.skeleton": "300ms",
  "motion.delay.tooltip": "500ms",
  "z.base": "0",
  "z.sticky": "10",
  "z.rail": "20",
  "z.dropdown": "100",
  "z.settings": "200",
  "z.modal": "300",
  "z.toast": "400",
  "z.tooltip": "500",
  "layout.gap": "8px",
  "layout.rail": "72px",
  "layout.railIcon": "48px",
  "layout.channelList": "240px",
  "layout.memberList": "240px",
  "layout.userBar": "56px",
  "layout.header": "48px",
  "layout.connectionStrip": "24px",
  "layout.composerMin": "44px",
  "layout.messageAvatar": "40px",
  "layout.messageGutter": "72px",
  "layout.voiceTileMin": "220px",
  "layout.modalSm": "440px",
  "layout.modalMd": "560px",
  "layout.modalLg": "760px",
  "layout.settingsNav": "220px",
  "layout.settingsContent": "720px",
  "layout.contentMin": "360px",
  "layout.menuMin": "188px",
  "layout.membersBreakpoint": "1200px",
  "layout.mobileBreakpoint": "768px",
  "layout.drawer": "300px",
  "layout.toastMax": "400px",
  "layout.emptyMax": "360px",
  "layout.focusStrip": "120px",
  "layout.mediaMaxW": "400px",
  "layout.mediaMaxH": "300px",
  "size.control.sm": "28px",
  "size.control.md": "36px",
  "size.control.lg": "44px",
  "size.icon.sm": "16px",
  "size.icon.md": "20px",
  "size.icon.lg": "24px",
  "size.iconStroke": "1.75",
  "size.avatar.xs": "20px",
  "size.avatar.sm": "24px",
  "size.avatar.md": "32px",
  "size.avatar.lg": "40px",
  "size.avatar.xl": "80px",
  "size.row.category": "28px",
  "size.row.channel": "32px",
  "size.row.voiceUser": "28px",
  "size.row.menuItem": "32px",
  "size.row.member": "44px",
  "size.chip": "24px",
  "size.switch.width": "40px",
  "size.switch.height": "24px",
  "size.switch.thumb": "18px",
  "size.checkbox": "20px",
  "size.attachmentThumb": "120px",
  "size.presenceDot": "10px",
  "size.badgeMin": "16px",
  "size.unreadPip": "8px"
});

/** Ham palet — UI kodunda KULLANMA (lint yakalamaz ama TASARIM.md yasaklar); yalnız yeni rol tasarlarken. */
export const ham = Object.freeze({
  "ada.50": "#fffaf2",
  "ada.100": "#f8f3eb",
  "ada.150": "#f3ede3",
  "ada.200": "#ebe2d5",
  "ada.300": "#e4d9c8",
  "ada.400": "#d8cbba",
  "ada.500": "#8a7a68",
  "ada.600": "#705e4d",
  "ada.700": "#544638",
  "ada.800": "#3d3125",
  "ada.900": "#2b2118",
  "ada.950": "#1c150e",
  "kiremit.50": "#fbebe4",
  "kiremit.100": "#f6d5c6",
  "kiremit.200": "#f0b19b",
  "kiremit.300": "#e88869",
  "kiremit.400": "#dd633d",
  "kiremit.500": "#cc4821",
  "kiremit.600": "#b53e1a",
  "kiremit.700": "#9e3414",
  "kiremit.800": "#7d260c",
  "kiremit.900": "#591805",
  "kiremit.950": "#3b0e02",
  "ada_ses.50": "#e4f2eb",
  "ada_ses.100": "#cde6d9",
  "ada_ses.200": "#a0d1b9",
  "ada_ses.300": "#6fb894",
  "ada_ses.400": "#429a70",
  "ada_ses.500": "#287553",
  "ada_ses.600": "#206144",
  "ada_ses.700": "#174d35",
  "ada_ses.800": "#103926",
  "ada_ses.900": "#0a2618",
  "ada_ses.950": "#05170d",
  "yorunge.50": "#f5f6ff",
  "yorunge.100": "#eef0ff",
  "yorunge.200": "#d8dcfa",
  "yorunge.300": "#b4b9e0",
  "yorunge.400": "#969cc4",
  "yorunge.500": "#6c7099",
  "yorunge.600": "#48407d",
  "yorunge.700": "#352f5e",
  "yorunge.750": "#262145",
  "yorunge.800": "#201c3b",
  "yorunge.850": "#1a1630",
  "yorunge.900": "#161329",
  "yorunge.950": "#0d0b1a",
  "turuncu.50": "#fff5eb",
  "turuncu.100": "#ffe5cc",
  "turuncu.200": "#ffd3a8",
  "turuncu.300": "#ffbe7a",
  "turuncu.400": "#ffa959",
  "turuncu.500": "#ff9d42",
  "turuncu.600": "#e68832",
  "turuncu.700": "#b8681d",
  "turuncu.800": "#7d430c",
  "turuncu.900": "#472712",
  "turuncu.950": "#2e1c10",
  "mor.vurgu": "#7b1fa2",
  "mor.koyu_vurgu": "#d1b8ff",
  "mor.subtle_acik": "#f4f0ff",
  "mor.subtle_koyu": "#2a0052",
  "mor.chip_acik": "#e7dbff",
  "mor.chip_koyu": "#48008c",
  "mor.chip_text_acik": "#2a0052",
  "mor.chip_text_koyu": "#e7dbff",
  "kokpit.50": "#edf5eb",
  "kokpit.100": "#d6e5d2",
  "kokpit.200": "#bed4b8",
  "kokpit.300": "#a2b89d",
  "kokpit.400": "#849c80",
  "kokpit.500": "#6f826b",
  "kokpit.600": "#61785e",
  "kokpit.700": "#384f38",
  "kokpit.750": "#283828",
  "kokpit.800": "#1f291f",
  "kokpit.850": "#1b231b",
  "kokpit.900": "#161d16",
  "kokpit.920": "#121712",
  "kokpit.950": "#0c0f0c",
  "asit_yesil.50": "#f5fedf",
  "asit_yesil.100": "#e8fcbe",
  "asit_yesil.200": "#d4faa4",
  "asit_yesil.300": "#c5f783",
  "asit_yesil.400": "#b6f36a",
  "asit_yesil.500": "#9ee04e",
  "asit_yesil.600": "#84c435",
  "asit_yesil.700": "#649922",
  "asit_yesil.800": "#466e13",
  "asit_yesil.900": "#243b17",
  "asit_yesil.950": "#192910",
  "kehribar.50": "#fff7eb",
  "kehribar.100": "#ffedcc",
  "kehribar.200": "#ffdb99",
  "kehribar.300": "#ffc46b",
  "kehribar.400": "#ffb547",
  "kehribar.500": "#f09e2b",
  "kehribar.600": "#cc7e14",
  "kehribar.700": "#9e5c06",
  "kehribar.800": "#6e3d00",
  "kehribar.900": "#382305",
  "kehribar.950": "#1f1400",
  "kirmizi.50": "#fff0f2",
  "kirmizi.100": "#ffd6dc",
  "kirmizi.200": "#ffb0bc",
  "kirmizi.300": "#ff7b8c",
  "kirmizi.400": "#ff5470",
  "kirmizi.500": "#d73449",
  "kirmizi.600": "#b8273a",
  "kirmizi.700": "#941829",
  "kirmizi.800": "#690b19",
  "kirmizi.900": "#3a101b",
  "kirmizi.950": "#24060e",
  "yesil.50": "#eafaf3",
  "yesil.100": "#c8f5e1",
  "yesil.200": "#95ecc6",
  "yesil.300": "#62e293",
  "yesil.400": "#4ce0b4",
  "yesil.500": "#40d67a",
  "yesil.600": "#2cd4a3",
  "yesil.700": "#257a37",
  "yesil.800": "#1e632d",
  "yesil.900": "#0c331a",
  "yesil.950": "#03210d",
  "camgobegi.50": "#eefbf8",
  "camgobegi.100": "#c9f6e8",
  "camgobegi.200": "#9decd5",
  "camgobegi.300": "#8ad6b8",
  "camgobegi.400": "#45bd96",
  "camgobegi.500": "#36d399",
  "camgobegi.600": "#2cd4a3",
  "camgobegi.700": "#0e8a6c",
  "camgobegi.800": "#0b6b55",
  "camgobegi.900": "#0a291a",
  "camgobegi.950": "#021f11",
  "sari.50": "#fefbe8",
  "sari.100": "#fdf4db",
  "sari.200": "#f8e6a0",
  "sari.300": "#f2cf55",
  "sari.400": "#e6a100",
  "sari.500": "#c88600",
  "sari.600": "#a86e00",
  "sari.700": "#7a5000",
  "sari.800": "#573800",
  "sari.900": "#332200",
  "sari.950": "#1f1400",
  "render.beyaz": "#ffffff",
  "render.siyah": "#0d0d0d",
  "render.yuzey_acik": "#fafafa",
  "render.yuzey_koyu": "#141414",
  "render.hover_acik": "#f0f0f0",
  "render.hover_koyu": "#222222",
  "render.selected_acik": "#eaeaea",
  "render.selected_koyu": "#282828",
  "render.overlay_koyu": "#1a1a1a",
  "render.metin_lead_acik": "#4d4d4d",
  "render.metin_lead_koyu": "#e3e3e3",
  "render.metin_muted_acik": "#6b6b6b",
  "render.metin_muted_koyu": "#8f8f8f",
  "render.border_subtle_acik": "#e3e3e3",
  "render.border_subtle_koyu": "#272727",
  "render.border_default_acik": "#c7c7c7",
  "render.border_default_koyu": "#404040",
  "render.border_strong_acik": "#0d0d0d",
  "render.border_strong_koyu": "#8f8f8f",
  "render.border_input_acik": "#6b6b6b",
  "render.border_input_koyu": "#6b6b6b",
  "siyah": "#000000",
  "beyaz": "#ffffff"
});
